import React from 'react';
import './contactsPage.css';

const ContactsPage = () => {
  
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">

          <h4>Page Contacts</h4>

        </div>
      </div>
    </div>
  );
};

export default ContactsPage;
